import { ChevronDown } from "lucide-react";
import { cn } from "../ui/utils";

interface FilterButtonProps {
  label: string;
  isOpen: boolean;
  onClick: () => void;
  hasSelection?: boolean;
  className?: string;
}

export function FilterButton({
  label,
  isOpen,
  onClick,
  hasSelection,
  className
}: FilterButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "h-10 px-4 py-1 overflow-hidden rounded border border-solid border-[#E0E0E0] justify-between items-center flex transition-colors bg-white hover:bg-gray-50 min-w-fit",
        hasSelection && "bg-blue-50 border-blue-200",
        className
      )}
    >
      <div className="text-[#3F4849] text-sm font-normal leading-5 whitespace-nowrap">
        {label}
      </div>
      <ChevronDown
        className={cn(
          "w-4 h-4 ml-2 text-[#3D5463] transition-transform duration-200 flex-shrink-0",
          isOpen && "rotate-180"
        )}
      />
    </button>
  );
}
